import { isEmpty, toUpper } from 'lodash/fp'
import { FC } from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'
import { SearchFiltersHumanizedRefinement } from 'search'
import { Card as BaseCard } from 'shared/components/CardDeprecated'
import styled from 'styled-components'
import SizeTile from './SizeTile'
import TileGrid from './TileGrid'
import { hide as hideUtil } from 'shared/lib'

const Card = styled(BaseCard)<{ isHidden: boolean }>`
  ${({ isHidden }) => hideUtil({ isHidden })};
`

interface PresentationSizeFilterProps {
  attribute: string
  hide: boolean
  items
  refine(value)
  isExpanded?: boolean
}

const PresentationSizeFilter: FC<PresentationSizeFilterProps> = ({
  hide,
  attribute,
  items,
  refine,
  isExpanded,
}) => {
  return !isEmpty(items) ? (
    <Card
      title={SearchFiltersHumanizedRefinement()[attribute]}
      isExpanded={isExpanded}
      isHidden={hide}
    >
      <TileGrid>
        {items.map(({ label, value, isRefined }) => (
          <SizeTile
            key={label}
            isSelected={isRefined}
            onClick={() => {
              refine(value)
            }}
          >
            {toUpper(label)}
          </SizeTile>
        ))}
      </TileGrid>
    </Card>
  ) : null
}

export default connectRefinementList(PresentationSizeFilter)
